import React from 'react';
import { ButtonLabel as ButtonLabelType } from '../type';
import './ButtonLabel.scss';

export type ButtonLabelProps = {
  children?: ButtonLabelType;
  id?: string;
};

function ButtonLabel({ children, id }: ButtonLabelProps) {
  return (
    <span
      className="elmo-btn__label"
      data-testid={`elmo-btn-label-${id || 'default'}`}
    >
      {children}
    </span>
  );
}

export default ButtonLabel;
